@if ($material()) {
    <cm-shaderball-asset-cell
        [output]="$shaderBallOutput()"
        [pending]="$shaderBallPending()"
        [hasCyclesMaterial]="$hasCyclesMaterial()"
        [canEdit]="$canEdit()"
        [canDownload]="$canDownload()"
        (render)="onShaderBallRender()"
        (rerender)="onShaderBallRerender()"
        (remove)="onShaderBallRemove()"
        (cancel)="onShaderBallCancel()"
        (retry)="onShaderBallRetry()"
        (preview)="onShaderBallPreview()"
    />
    <cm-thumbnail-asset-cell
        #thumbnailCell
        [outputs]="$thumbnailOutputs()"
        [pendingTypes]="$thumbnailPendingTypes()"
        [hasCyclesMaterial]="$hasCyclesMaterial()"
        [canEdit]="$canEdit()"
        [canDownload]="$canDownload()"
        (render)="onThumbnailRender($event)"
        (rerender)="onThumbnailRerender($event)"
        (remove)="onThumbnailRemove($event)"
        (cancel)="onThumbnailCancel($event)"
        (retry)="onThumbnailRetry($event)"
        (preview)="onThumbnailPreview()"
    />
    <cm-tileable-asset-cell
        [output]="$tileableOutput()"
        [pending]="$tileablePending()"
        [dimensionsCm]="$tileableDimensionsCm()"
        [hasCyclesMaterial]="$hasCyclesMaterial()"
        [canEdit]="$canEdit()"
        [canDownload]="$canDownload()"
        (render)="onTileableRender()"
        (rerender)="onTileableRerender()"
        (remove)="onTileableRemove()"
        (cancel)="onTileableCancel()"
        (retry)="onTileableRetry()"
        (preview)="onTileablePreview()"
    />
    <cm-pbr-asset-cell
        [outputs]="$pbrExportOutputs()"
        [pendingTypes]="$pbrExportPendingTypes()"
        [hasCyclesMaterial]="$hasCyclesMaterial()"
        [canEdit]="$canEdit()"
        [canDownload]="$canDownload()"
        (render)="onPbrRender($event)"
        (rerender)="onPbrRerender($event)"
        (remove)="onPbrRemove($event)"
        (cancel)="onPbrCancel($event)"
        (retry)="onPbrRetry($event)"
    />
    <!-- Only a real grid item when pinned, so the four fixed tiles stay a clean 2x2 with no trailing row/gap. -->
    @if ($pinnedImage()) {
        <cm-pinned-asset-cell [pinnedImage]="$pinnedImage()" [canEdit]="$canEdit()" (unpin)="onUnpin()" (preview)="onPinnedPreview()" />
    }

    <cm-image-viewer #imageViewer />
} @else {
    <div class="cm-cell-placeholder"></div>
    <div class="cm-cell-placeholder"></div>
    <div class="cm-cell-placeholder"></div>
    <div class="cm-cell-placeholder"></div>
}
